module.exports = __webpack_public_path__ + "img/14_1805_sshouse.6baf2dd3.jpg";